module.exports = __webpack_public_path__ + "img/_con3.a984e629.png";